import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';

import { ResourcesService } from '../resources.service';

@Component({
    selector: 'app-semana',
    templateUrl: './semana.component.html',
    styleUrls: ['./semana.component.css']
})
export class SemanaComponent implements OnInit {

    user : any = {}
    aves: any = [];
    semana: any = [];
    idsemana: string;
    title: string = '';
    galpon: string = '';
    corral: string = '';
    current_corral: number = 0;
    idlote: number = 0;
    permitir: boolean = true;

    constructor(
        private http: HttpClient,
        private route: ActivatedRoute,
        private router: Router,
        public resource: ResourcesService,
        private _location: Location
    ) {

        this.route.paramMap.subscribe(params => {
            let user = localStorage.getItem('user')
            this.user = JSON.parse(user)
            if (user == undefined) {
                this.router.navigate(['/']);
                return
            } else {
                this.idsemana = params.get('idsemana');
                this.idlote = Number(params.get('idlote'));
                var url_semanas = resource.route + '/semanas/detalle/' + this.idsemana;

                this.http.get(url_semanas).subscribe(
                    (data: any) => {
                        console.log('semana', data)
                        this.semana = data;
                        this.aves = JSON.parse(data.detalle);
                        console.log('aves', this.aves)
                        if(this.user.TipoPesaje == 2){
                            this.getNameNacimiento(this.semana.idcorral)
                        }else{
                            this.getNameCorral(this.semana.idcorral)
                        }
                        resource.updateLocalStorageFromOnline()
                    },
                    error => {
                        console.log('error semanas online', error)
                        var semanas = localStorage.getItem('semanas')
                        semanas = JSON.parse(semanas)
                        console.log('semanas online', semanas)
                        for (let i = 0; i < semanas.length; i++) {
                            if (semanas[i]['idsemana'] == this.idsemana) {
                                this.semana = semanas[i]
                                this.aves = JSON.parse(semanas[i]['detalle']);
                                if(this.user.TipoPesaje == 2){
                                    this.getNameNacimiento(this.semana.idcorral)
                                }else{
                                    this.getNameCorral(this.semana.idcorral)
                                }
                            }
                        }
                    }
                );
            }
        });

    }

    getNameCorral(idcorral) {
        var corrales = localStorage.getItem('corrales')
        corrales = JSON.parse(corrales);
        for (let i = 0; i < corrales.length; i++) {
            if (corrales[i]['id'] == idcorral) {
                this.corral = corrales[i]['lote']
            }
        }
    }

    getNameNacimiento(idcorral) {
        var nacimientos = JSON.parse(localStorage.getItem('nacimientos'))
        for (let i = 0; i < nacimientos.length; i++) {
            const n = nacimientos[i]
            if (n.idNacimiento == idcorral) {
                for (let j = 0; j < n.detalle.length; j++) {
                    const d = n.detalle[j];
                    if(d.idLote == this.idlote){
                        this.corral = d['CodigoLote']
                    }
                }
            }
        }
    }

    ngOnInit(): void {
    }

    regresar() {
        this.router.navigate(['/pesajes/' + this.idlote + "/" + this.semana.idcorral]);
    }

}
